import { Checkbox, CheckboxProps, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faCirclePlus, faDeleteLeft, faTrash } from "@fortawesome/free-solid-svg-icons";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { dashboardSelectProps, InputListProps, popupType } from "../../types/types";
import styled from "@emotion/styled";
import "./Switch.css"
import TextField from "@mui/material/TextField";
import { TextFieldProps } from "@mui/material";
import { CameraImagePropTypes } from "../../types";
import { openPopup } from "../../stateManagement/actions/popupActions";
import QuestionHeading from "../heading/QuestionHeading";
import { UiConfigImageUpload } from "../uiConfig/UiConfigImageUpload";
import { getNewConfiguration } from "../../services/uiConfigService";
import { isEqual } from "lodash";
import "./Input.css"
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import QuestionHeadingNew from "../heading/QuestionHeadingNew";

export const InputList=(props:InputListProps)=>{

  const handleListValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,index:number) => {
    // const keyName = e.target.name;
    const updatedList=props.values?.[props.configName].value
    updatedList[index]=e.target.value;
    props.setValues({
        ...props.values,
        [props.configName]: {...props.values[props.configName], value:updatedList, isValueUpdated:true} 
    })
}

const addField =()=>{
  const updatedList=props.values?.[props.configName].value
  updatedList.push("");
  props.setValues({
    ...props.values,
    [props.configName]: {...props.values[props.configName], value:updatedList, isValueUpdated:true} 
})
}

const deleteField =(index:number)=>{
  const updatedList=props.values?.[props.configName].value
  updatedList.splice(index, 1);
  props.setValues({
    ...props.values,
    [props.configName]: {...props.values[props.configName], value:updatedList, isValueUpdated:true} 
})
}

  return (
    <>
    <div className='question_with_icon' style={{display:"flex",justifyContent:"space-between"}}>
    <QuestionHeadingNew>
        {props.question}
    </QuestionHeadingNew>

    <FontAwesomeIcon
    onClick={addField}
    className="footer_config_plus_icon"
    icon={faCirclePlus}
    />
    </div>
    {
      props.values?.[props.configName].value.map((element:string, index:number) => {
        return (
          <div className="list_answer_container">
            {/* <div> */}
              <Input value={element} onChange={(e) => handleListValueChange(e, index)} name={props.name} />
              <FontAwesomeIcon
                onClick={() => { deleteField(index) }}
                className="footer_config_plus_icon"
                icon={faTrash}
              />
            {/* </div> */}

          </div>
        )
        })
      }
    </>
  ) 
}

type ExtendedTextFieldProps = TextFieldProps & {
  min?: number;
  regex?:string;
  onValidationChange?: (id: string, isValid: boolean) => void;
  setAreDataFieldsValid?:(isValid: boolean) => void;
};

const Input = (props: ExtendedTextFieldProps) => {
  const [error, setError] = useState(false);

  useEffect(() => {
  
    const value: string =
    props.value !== undefined && props.value !== null
      ? String(props.value)
      : "";

    const isValid =
      (!props.min || value.length >= props.min);
     const regex = new RegExp(props.regex??""); 
     const regexValid=regex.test(value)
    
    setError((!isValid||!regexValid));
  props.setAreDataFieldsValid?.((isValid&&regexValid))
  
    props.onValidationChange &&
      props.onValidationChange(props.name ?? "", isValid); 
  }, [props.value, props.min, props.onValidationChange]);

  return (
    <div style={{width:"100%"}}>
      <TextField
        id="outlined-basic"
        size="small"
        inputProps={props.inputProps}
        sx={{
        width:"100%",
    mt: 0,
    mb: error ? 0 : 2,
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
        width: "100%", 
    },
  }}
        variant="outlined"
        error={error}
        {...props}
      />
      {error && (
        <Typography sx={{ color: "red", fontSize: "0.8rem" }}>
          This field is empty or invalid.
        </Typography>
      )}
    </div>
  );
};

type dashboardCheckboxType = CheckboxProps & {
  label: string;
};

export const DashboardCheckbox = (props: dashboardCheckboxType) => {
  return (
    <span
      style={{
        fontSize: "1.1rem",
        display: "inline-flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Checkbox
        aria-label={props.label}
        {...props}
        defaultChecked={false}
        size="medium"
      />
      {props.label}
    </span>
  );
};
// export const DashboardToggle = (props: dashboardCheckboxType) => {
//   const checked = Boolean(props.checked);

//   return (
//     <span
//       style={{
//         fontSize: "1.1rem",
//         display: "inline-flex",
//         justifyContent: "flex-start",
//         alignItems: "center",
//         gap: "0.5rem",
//       }}
//     >
//       <Switch
//         aria-label={props.label}
//         {...props}
//         checked={checked}
//         onChange={props.onChange}
//      size="medium"  
//        sx={{ transform: "scale(1.3)" }} 
//       />
//       {/* <span>{checked ? "Yes" : "No"}</span> */}
//     </span>
//   );
// };

export const DashboardToggleSwitch = (props:dashboardCheckboxType) => {
    const checked = Boolean(props.checked);
 const id = `react-switch-${props.name}`;
  return (
    <>
      <input
      name={props.name}
      checked={checked}
      onChange={(e)=>props.onChange?.(e,e.target.checked)}
        className="react-switch-checkbox"
        id={id}
        type="checkbox"
      />
      <label
       style={{ background: checked ?"#00C6B1" : undefined }}
        className="react-switch-label"
        htmlFor={id}
      >
        <span className={`react-switch-button`} />
      </label>
    </>
  );
};




/**
 * This function renders an image input
 * @param {image}    image     It is the value of the current image
 * @param {setImage} setImage   It is used to  set the image value
 * @param {currImage} currImage If you want to show a default image
 * @param {name} name give a name to access the input
 * @param {validHeight} validHeight checks the height of the image should be equal to this
 * @param {validWidth} validWidth checks the width of the image should be equal to this
 * @param {maximumWidth} maximumWidth checks the width of the image should be less than this
 * @param {maximumHeight} maximumHeight  checks the height of the image should be less than this
 *
 */

export const CameraImage = (props: CameraImagePropTypes) => {
  const Wrapper = styled("span")(`
    border: grey dashed 1px;
    border-radius:4%;
    background-color:#F5F5F5;
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items:center;
    position: relative; /* Make Wrapper relative for positioning the remove button */
    width:${props.width || "12rem"};
    height: ${props.height || "7.5rem"};
    color:var(--dashboard-secondary-color);
    gap:0.3rem;
    cursor:pointer;
  `);

  const SelectedImage = styled("img")(`
    width:2.8rem;
    height:2.8rem;
  `);

  const RemoveButton = styled("span")(`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background-color: #227C9D;
    color: white;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10; /* Ensure the button appears above the image */
  `);

  const {
    image,
    setImage,
    currImage,
    name,
    uploadText,
    validWidth,
    validHeight,
    maximumHeight,
    maximumWidth,
    disable,
    removeButton,
    removeFunction,
    maxSize,
    nameValidation,
  } = props;

  const [showImage, setShowImage] = useState<string>();
  const imageRef = useRef<HTMLInputElement>(null);
  const showImageRef = useRef<HTMLImageElement>(null);
  const { translate } = usePortalTranslation();

  const handleChange = () => {
    if (disable) {
      return;
    }
    if (imageRef?.current) imageRef.current.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disable) {
      return;
    }
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      let img = e.target.files[0];
      reader.onload = function (e) {
        let image: HTMLImageElement = new Image();
        image.src = e?.target?.result as string;
        image.onload = function () {
          let height = image.height;
          let width = image.width;

          if (maxSize && img.size > maxSize * 1024) {
            setImage("");
            setShowImage("");
            openPopup(
              "Error",
              `The image size should be less than ${maxSize} KB`
            );
            return;
          }

          const nameValidationResponse = nameValidation
            ? nameValidation(img.name)
            : undefined;
          if (
            nameValidationResponse &&
            nameValidationResponse.status === "failed"
          ) {
            setImage("");
            setShowImage("");
            openPopup(
              "Error",
              nameValidationResponse.message ?? "Name Validation Failure"
            );
            return;
          }

          if (validHeight || validWidth || maximumHeight || maximumWidth) {
            if (validHeight && validHeight !== height) {
              setImage("");
              setShowImage("");
              openPopup(
                "Error",
                `The image size should have ${validHeight} height`
              );
            } else if (validWidth && validWidth !== width) {
              setImage("");
              setShowImage("");
              openPopup(
                "Error",
                `The image size should have ${validWidth} width`
              );
            } else if (maximumHeight && height && height > maximumHeight) {
              setImage("");
              setShowImage("");
              openPopup(
                "Error",
                `The image size should have ${maximumHeight} maximum height`
              );
            } else if (maximumWidth && width && width > maximumWidth) {
              setImage("");
              setShowImage("");
              openPopup(
                "Error",
                `The image size should have ${maximumWidth} maximum width`
              );
            } else {
              setImage(img);
              setShowImage(URL.createObjectURL(img));
              return true;
            }
          } else {
            setImage(img);
            setShowImage(URL.createObjectURL(img));
            return true;
          }
        };
      };
      reader.onerror = function () {
        setImage("");
        setShowImage("");
        openPopup("Error", `Error occurred`);
      };
    }
  };

  return (
    <Wrapper onClick={handleChange}>
      {showImage && image ? (
        <>
          <SelectedImage
            ref={showImageRef}
            src={showImage}
            className="selectedImage"
          />
          {removeButton && (
            <RemoveButton onClick={removeFunction}>×</RemoveButton>
          )}
        </>
      ) : currImage ? (
        <>
          <SelectedImage src={currImage} className="selectedImage" />
          {removeButton && (
            <RemoveButton onClick={removeFunction}>×</RemoveButton>
          )}
        </>
      ) : (
        <FontAwesomeIcon
          icon={faCamera}
          color="var(--dashboard-secondary-color)"
          style={{ width: "2.5rem", height: "2.8rem" }}
        />
      )}
      <input
        {...props}
        onChange={handleFileChange}
        type="file"
        name={name ? name : "file"}
        ref={imageRef}
        style={{ display: "none" }}
        accept="image/*"
      />
      {!disable && (
        <span style={{ fontSize: "14px" }}>
           {translate(TranslationEnum.ui_config,`Upload ${uploadText ? uploadText : "Image"}`)}  
        </span>
      )}
    </Wrapper>
  );
};

export const DashboardSelect = (props: dashboardSelectProps) => {
  const { label, selectLableId, options,disabled } = props;
  return (
    <FormControl margin="dense" style={{ minWidth: "32%" }}>
      <InputLabel id={selectLableId}>{label}</InputLabel>
      <Select size="small"
      sx={{borderRadius:"8px" }}
        labelId={selectLableId}
        color="primary"
        defaultValue={""}
        {...props}
       
      >
        {options?.map(
          (option: { title: string; value: string | number } | string) => {
            if (typeof option === "object") {
              return (
                <MenuItem value={option.value}>
                  <span className="first_letter_capital">{option.title}</span>
                </MenuItem>
              );
            } else
              return (
                <MenuItem value={option}>
                  <span className="first_letter_capital">{option}</span>
                </MenuItem>
              );
          }
        )}
      </Select>
    </FormControl>
  );
};


export default Input;
